import AppConfig from "../../AppConfig.js";
import * as booking_actions from "../booking/actions_booking.svelte.js";
import {ENTRY_DURATION_DAY} from "../../AppConstants.js";
import * as progress_actions from "../progress/actions_progress.svelte.js";
import {progress} from "../progress/feature.progress.svelte.js";
import * as booking_select_export from "../booking/booking.scenarios.select.export.svelte.js";

export const debug = $state({
  bLogToConsole: false,
  bAreHMKDevToolsActive: false,
  oLatestIsMoveAllowedReport: false,
  bDebugHideReceipt: false, // wordt bijv vanuit App.Sandbox dynamisch op true gezet
  aMessages: [
    {sFeature: 'booking', sMethod: 'testMethod', oMessage: {sRandomText: 'hoi1'}},
    {sFeature: 'booking', sMethod: 'testMethod', oMessage: {sRandomText: 'hoi2'}},
    {sFeature: 'booking', sMethod: 'testMethod', oMessage: {sRandomText: 'hoi3'}}
  ]
});

window.hmk_debug = () => {
  console.log($state.snapshot(debug))
}

window.hmk_export = () => {
  console.log(booking_select_export.getBookingExport(true));
}

window.hmk_show_calculation_logs = () => {
  AppConfig.bLogCalculateTotalsStepsToConsole = true;
  booking_actions.handleBookingUpdated('hmk_show_calculation_logs');
}


window.hmk_form = () => {
  return;
  // alert('woop2');
  booking_actions.setPreferredPartOfDay(ENTRY_DURATION_DAY);
  booking_actions.setNrOfPeople(2);
  // progress_actions.goToStep(20);
  booking_actions.setArrivalDate(12, 12, 2025);
  // progress_actions.goToStep(30);
  booking_actions.setArrivalTime(1030);
  booking_actions.setDepartureTime(1700);
  // progress_actions.goToStep(40);
  // progress_actions.goToStep(50);
  progress.bIsReceiptReadyToBeVisible = true;
  progress_actions.goToStep(60);
}


